import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['common', 'invoices']);

  return (
    <>
      <Header.Root>
        <Header.Content backTo={routes.invoices} title={t('invoices:createEdit.title.create')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('invoices:details.error.title')} />
      </Container>
    </>
  );
};
